import { render, staticRenderFns } from "./layout-product-certificate.vue?vue&type=template&id=71f750d6"
import script from "./layout-product-certificate.vue?vue&type=script&lang=js"
export * from "./layout-product-certificate.vue?vue&type=script&lang=js"
import style0 from "./layout-product-certificate.vue?vue&type=style&index=0&id=71f750d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports